let assetList;

$(document).ready(function() {
    assetList = $(".eventlist-event-body-item");

    if (assetList.length === 0) {
        $(".eventdocumentlist-event").hide();
    }
});
